export const isToday = (dateString: string): boolean => {
  const date = new Date(dateString);
  const now = new Date();
  return (
    date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()
  );
};
